/* Copy-paste of Vadim's extension*/

import $ from 'jquery';

/**
 * This is simple plugin that checks when window is scrolled
 * to the bottom of the element and fires event in this case
 */
export class InfiniteScroll {
	_$el;
	_$window;
	_eventHandler;
	_needMore;

	_clNeedMore = $.Callbacks();

	constructor(element, options) {
		this._$el = $(element);
		this._$window = $(window);
		this._o = {
			/**
			 * If distance in pixels between bottom of the window and bottom of the element
			 * becomes less than this value - event is fired
			 */
			distance: 500,
			/**
			 * Event handler
			 */
			onNeedMore: null,

			...options
		};
		if(this._o.onNeedMore) {
			this._clNeedMore.add(this._o.onNeedMore);
		}
	}

	/**
	 * Subscribe to needed events and start monitoring
	 */
	on() {
		if (this._eventHandler) {
			return;
		}
		this._eventHandler = this.update.bind(this);
		this._$window.on('scroll resize', this._eventHandler);
		this.update();
	}

	/**
	 * Unsubscribe from all events and stop monitoring
	 */
	off() {
		if (!this._eventHandler) {
			return;
		}
		this._$window.off('scroll resize', this._eventHandler);
		this._eventHandler = null;
	}

	/**
	 * Manual update. Event will be fired immediately if needed.
	 */
	update(checkVisible = true) {
		if(checkVisible && !this._$el.is(':visible')) {
			return;
		}
		const blockEnd = this._$el.offset().top + this._$el.outerHeight();
		const windowHeight = this._$window.height();
		const windowScrollTop = this._$window.scrollTop();
		let isNearBottom = blockEnd < windowScrollTop + windowHeight + this._o.distance;

		if(isNearBottom != this._needMore) {
			this._needMore = isNearBottom;

			if(isNearBottom) {
				this._clNeedMore.fireWith(this._$el[0], [this._loadedMoreCallback.bind(this)]);
			}
		}
	}

    /**
	 * Change internal state in response to loaded more event
     */
    _loadedMoreCallback() {
    	this._needMore = false;
	}

	/**
	 * Add event handler
	 * @param callback
	 */
	onNeedMore(callback) {
		this._clNeedMore.add(callback);
	}

	/**
	 * Remove event handler
	 * @param callback
	 */
	offNeedMore(callback) {
		this._clNeedMore.remove(callback);
	}
}

$.fn.zInfiniteScroll = function (options) {
	let o = $.extend({
		fetch: null,
		clear: null,
		show: null,
		enabled: null,
		finished: null,
        getCurrentCount: null,
        countPerPage: null,
        totalCount: Number.MAX_VALUE,
		selector: '*',
		btnShowMore: null,
		loading: null,
		maxAutoloadPages: null,
		checkViewport: true,
		autoStart: true
	}, options);

	let $wrapper = $(this);
	let $window = $(window);
	let $btnShowMore = $(o.btnShowMore);
	let $loading = $(o.loading);
	let getCurrentCount = $.isFunction(o.getCurrentCount)
		? o.getCurrentCount : () => $wrapper.children(o.selector).length;
    let currentPage = (o.countPerPage === null) ? 1 : () => { return getCurrentCount() / o.countPerPage; };
	let inProgress = false;
	let isReloading = false;
	let finished = false;
	let t = new Throttler(50);

	$btnShowMore.click(function () {
		$btnShowMore.hide();
		loadMore(function (hasMore) {
			if (hasMore) {
				$btnShowMore.show();
			}
		});
	});

	o.totalCount = +o.totalCount;
	o.maxAutoloadPages = +o.maxAutoloadPages;

	if (o.autoStart) {
		if (getCurrentCount() < o.totalCount) {
			start();
		} else {
			finished = true;
			if ($.isFunction(o.finished)) {
				o.finished();
			}
		}
	}

	return {
		on: function () {
			finished = false;
			if (getCurrentCount() < o.totalCount) {
				start();
			} else {
				finished = true;
				if ($.isFunction(o.finished)) {
					o.finished();
				}
			}
		},
		off: function () {
			stop();
			finished = true;
		},
		reload: function () {
            finished = false;
            if(!$.isFunction(currentPage)) {
                currentPage = 0;
            }
            o.totalCount = Number.MAX_VALUE;

            if($.isFunction(o.clear)) {
            	o.clear();
			} else {
                $wrapper.children(o.selector).remove();
			}

			if(inProgress) {
            	isReloading = true;
			} else {
				loadRoutine();
			}
        }
	};

	function start() {
		if (!finished) {
			$window.on('scroll', onScroll);
		}
	}

	function stop() {
		$window.off('scroll', onScroll);
	}

	function onScroll() {
		if ((unwrap(o.enabled) === false) || inProgress || !t.ready() || !$wrapper.is(':visible')) {
			return;
		}

		let blockEnd = $wrapper.offset().top + $wrapper.height();
		let windowHeight = $window.height();
		let windowScrollTop = $window.scrollTop();
		let isNearBottom = blockEnd < windowScrollTop + windowHeight + 500;
		let isInViewport = !o.checkViewport || blockEnd > windowScrollTop + 50;
		let ready = isNearBottom && isInViewport;

		if (ready) {
            loadRoutine();
		}
	}

	function loadRoutine() {
        stop();
        loadMore(function () {
            let needMore = getCurrentCount() < o.totalCount;
            if (needMore) {
                if (!o.maxAutoloadPages || unwrap(currentPage) < o.maxAutoloadPages) {
                    t.reset();
                    start();
                } else {
                    $btnShowMore.show();
                }
            } else {
            	finished = true;
            	if ($.isFunction(o.finished)) {
                	o.finished();
            	}
            }
        });
    }

	function loadMore(callback) {
		if (inProgress) {
			return;
		}
		inProgress = true;
		$loading.show();

		o.fetch(unwrap(currentPage) + 1, function ($blocks) {
			if(isReloading) {
                isReloading = false;
                inProgress = false;

                loadRoutine();
                return;
			}
			let count = 0;
			if ($.isFunction(o.show)) {
				count = o.show($blocks);
			} else {
				$blocks.addClass('fadein');
				$wrapper.append($blocks);
				count = $blocks.length;
			}

            if(!$.isFunction(currentPage)) {
                currentPage++;
            }
			inProgress = false;
			$loading.hide();

			if ((count === 0) || (o.countPerPage !== null && count < o.countPerPage)) {
				// force stop because no more data on server
				o.totalCount = getCurrentCount();
			}

			callback();
		});
	}
};

function unwrap(value) {
	return $.isFunction(value) ? value() : value;
}

class Throttler {
	constructor(period) {
		this.period = +period;
		this.start = +new Date();
	}

	ready() {
		let ready = (+new Date()) - this.start >= this.period;
		if (ready) {
			this.reset();
		}
		return ready;
	};

	reset() {
		this.start = +new Date();
	};
}



// WEBPACK FOOTER //
// ./lib/zinfinitescroll/index.js